import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

import { RESULTS_PATH } from 'containers/App/Routes';
import Logger from 'utils/Logger';

export const CheckoutRedirect = () => {
  const { clinicId } = useParams<{ clinicId: string }>();
  if (!clinicId) {
    Logger.error('No clinicId passed to CheckoutRedirect', { clinicId });
    return null;
  }
  return <Redirect to={`${RESULTS_PATH}/${clinicId}/checkout-v2`} />;
};